import {
  ColDef,
  GridApi,
  GridOptions,
} from 'ag-grid-community';
import { camelCaseFormatter } from '@app/app/components/grid-components/grid-formatters';
import {
  notificationsDefaultMinWidth,
  GRID_BASE_CONFIG,
  GRID_BASE_DEFAULT_COL_DEF,
} from './notifications-constants';


export const sizeColsToFit = (api: GridApi) => {
  api.sizeColumnsToFit({
    defaultMinWidth: notificationsDefaultMinWidth,
  });
};


export const notificationsGridConfig: GridOptions = {
  ...GRID_BASE_CONFIG,
}

export const notificationsGridDefaultColDef: ColDef = {
  ...GRID_BASE_DEFAULT_COL_DEF,
}

export enum ActivityType {
  CONTRACT_IN = 'contractIn',
  CONTRACT_REQUESTED = 'contractRequested',
  DEAL_ASSIGNED_TO_LENDER = 'dealAssignedToLender',
  DOCUMENT_ATTACHED = 'documentAttached',
  FUNDING_DESK_TO_LENDER_REQUEST_CREATED = 'fundingDeskToLenderRequestCreated',
  FUNDING_MANAGER_TO_LENDER_REQUEST_CREATED = 'fundingManagerToLenderRequestCreated',
  LENDER_TO_FUNDING_DESK_REQUEST_CREATED = 'lenderToFundingDeskRequestCreated',
  REQUEST_COMMENT_ADDED = 'requestCommentAdded',
  DEAL_NOTE = 'dealNote',
  OFFER_ACCEPTED = 'offerAccepted',
  OFFER_CREATED = 'offerCreated',
  OFFER_UPDATED = 'offerUpdated',
  OFFER_DELETED = 'offerDeleted',
  OFFER_BORROWER_DECLINED = 'offerBorrowerDeclined',
  OFFER_BORROWER_ACCEPTED = 'offerBorrowerAccepted'
}

export const notificationTypeTransformer = (activityType: string): string => {
  switch (activityType) {
    case ActivityType.CONTRACT_IN:
      return 'Contract submitted';
    case ActivityType.CONTRACT_REQUESTED:
      return 'Contract requested';
    case ActivityType.DEAL_ASSIGNED_TO_LENDER:
      return 'Deal assigned';
    case ActivityType.DOCUMENT_ATTACHED:
      return 'Document added';
    case ActivityType.FUNDING_DESK_TO_LENDER_REQUEST_CREATED:
    case ActivityType.FUNDING_MANAGER_TO_LENDER_REQUEST_CREATED:
      return 'New message received';
    case ActivityType.LENDER_TO_FUNDING_DESK_REQUEST_CREATED:
      return 'New message sent';
    case ActivityType.REQUEST_COMMENT_ADDED:
      return 'New message reply';
    case ActivityType.DEAL_NOTE:
      return 'New deal note';
    case ActivityType.OFFER_ACCEPTED:
      return 'Offer accepted';
    case ActivityType.OFFER_CREATED:
      return 'Offer created';
    case ActivityType.OFFER_UPDATED:
      return 'Offer details updated';
    case ActivityType.OFFER_DELETED:
      return 'Offer removed';
    case ActivityType.OFFER_BORROWER_DECLINED:
      return 'Offer declined';
    case ActivityType.OFFER_BORROWER_ACCEPTED:
      return 'Offer accepted';
    default:
      return camelCaseFormatter({ value: activityType });
  }
}

